(function () {
  class MovieSymbolAnimator extends PIXI.Container {
    constructor() {
      super();
      this.visible = false;
      this._trackInfo = undefined;
      this._bgMovie = undefined;
      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
    }

    play(trackInfo, loop, onCellAnimFinishedCb) {
      this._trackInfo = trackInfo;
      this.initialiseSymbolMovie(trackInfo.getPosition());

      //Oversized symbols do not the underneath to be hidden
      if (!loop) {
        trackInfo.showSymbol(false);
      }

      const stake = gameController.getCurrentModeStake();

      this._trackInfo.isOverSizeOverlay =
        resourceManager.configuration["symbols"][
          this.Props.playData.definition
        ].isOverSizeOverlay;

      const isPrizeTrigger =
        gameController.reelsPrize > stake || this._alwaysPlay;
      const isOversizedSymbol = gameController.overSizedGroup.includes(
        trackInfo.symbolId
      );
      const isMoonSpin =
        trackInfo.symbolId === gameData.symbols["Symbol_Moon_Spin"].ID;

      const handleOversizeAndCallback = () => {
        if (isOversizedSymbol && !gameController.slamStopped) {
          gameController.showOversizeMovie(trackInfo);
        }
        onCellAnimFinishedCb(this);
      };

      if (isPrizeTrigger) {
        this._movie.onComplete = handleOversizeAndCallback;
        this._movie.gotoAndPlay(0);

        if (this._bgMovie) {
          this._bgMovie.gotoAndPlay(0);
        }
      } else {
        if (isMoonSpin) {
          this._movie.loop = true;
          this._movie.gotoAndPlay(0);
        }

        if (this._bgMovie) {
          this._bgMovie.visible = false;
        }

        if (this._lowWinmovie) {
          this._lowWinmovie.onComplete = () => {
            if (isOversizedSymbol && !gameController.slamStopped) {
              gameController.showOversizeMovie(trackInfo);
            }
            this._lowWinmovie.visible = false;
            onCellAnimFinishedCb(this);
          };

          this._lowWinmovie.visible = true;
          this._lowWinmovie.gotoAndPlay(0);
        } else if (!trackInfo.isOverSizeOverlay) {
          // Keep 1-frame overlay symbols looping to maintain z-index
          timerManager.addTimeout(1350, () => {
            onCellAnimFinishedCb(this); //<keeping the for a bit
          });
        }
      }
    }

    initialiseSymbolMovie(symPos) {
      this.visible = true;
      this._movie.gotoAndStop(0);
      if (this._bgMovie !== undefined) {
        this._bgMovie.gotoAndStop(0);
      }
      if (this._fsmovie !== undefined) {
        this._fsmovie.gotoAndStop(0);
      }
      this.position.set(
        symPos.x + this._positionOffset.x,
        symPos.y + this._positionOffset.y
      );
    }

    getTrackInfo() {
      return this._trackInfo;
    }

    finalise() {
      this.visible = false;
      this._trackInfo.showSymbol(true);
      this._trackInfo = undefined;
    }

    untrack() {
      if (this._trackInfo) {
        this._trackInfo.untrack();
      }
    }

    skip() {
      this.untrack();
    }

    onOrientationChange() {
      if (this._trackInfo !== undefined) {
        let symPos = this._trackInfo.getPosition();
        this.position.set(
          symPos.x + this._positionOffset.x,
          symPos.y + this._positionOffset.y
        );
      }
    }
  }

  let create = function () {
    return new MovieSymbolAnimator();
  };

  let initialise = function (json, instance) {
    if (json.playData.includeBgAnim) {
      instance._bgMovie = resourceManager.createObject(
        "movie",
        "bgAnim",
        instance.name,
        {
          definition: "Symbol_BgWin",
        }
      );
      instance._bgMovie.loop = 0;
      instance._bgMovie.gotoAndStop();
      instance._bgMovie.anchor.set(0.5);
    }
    instance._movie = resourceManager.createObject(
      "movie",
      json.playData.definition,
      instance.name,
      {
        definition: json.playData.definition,
      }
    );
    instance._movie.loop = false;
    instance._movie.gotoAndStop(0);
    instance._movie.anchor.set(0.5);
    if (json.playData.lowWinDefinition !== undefined) {
      instance._lowWinmovie = resourceManager.createObject(
        "movie",
        json.playData.lowWinDefinition,
        instance.name,
        {
          definition: json.playData.lowWinDefinition,
        }
      );
      instance._lowWinmovie.loop = false;
      instance._lowWinmovie.gotoAndStop(0);
      instance._lowWinmovie.anchor.set(0.5);
      instance._lowWinmovie.visible = false;
    }

    instance._positionOffset = { x: 0, y: 0 };
    if (json.playData.posOffset) {
      instance._positionOffset = json.playData.posOffset;
    }
    if (json.playData.alwaysPlay) {
      instance._alwaysPlay = json.playData.alwaysPlay;
    }
  };

  let getRequiredFiles = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "movieSymbolAnimator",
    create,
    initialise,
    getRequiredFiles
  );
})();
